import { setWebSocketReducer } from "../slices/socketSlice";

function createWebSocket(token, onMessage, dispatch) {
  console.log(token, " = userSubbbbbb");
  if(token.includes("User#")){
    token = token.split("#")[1];
  }
  const url = `wss://0sy00ttkp1.execute-api.us-east-2.amazonaws.com/Prod/?token=${token}`;

  let webSocket = null;
  let reconnectInterval = 1000; // Initial reconnect interval
  const maxReconnectInterval = 30000; // Max reconnect interval

  const connect = () => {
    webSocket = new WebSocket(url);

    webSocket.addEventListener('open', e => {
      console.log('WebSocket is connected', e);
      reconnectInterval = 1000; // Reset reconnect interval on successful connection
      dispatch(setWebSocketReducer(webSocket));
    });

    webSocket.addEventListener('close', e => {
      console.log('WebSocket is closed', e);
      setTimeout(connect, reconnectInterval);
      reconnectInterval = Math.min(reconnectInterval * 2, maxReconnectInterval);
    });

    webSocket.addEventListener('error', e => {
      console.error('WebSocket is in error', e);
      webSocket.close(); // Ensure the close handler is called
    });

    webSocket.addEventListener('message', e => {
      console.log('WebSocket received a message:', e);
      if (typeof onMessage === 'function') {
        onMessage(e);
      }

      // Parse the message and handle custom types
      try {
        const message = JSON.parse(e.data);
        if (message.type === 'allUserList') {
          console.log('allUserList', message.data);
        } else if (message.type === 'getuserlist') {
          console.log('getuserlist', message.data);
        }
      } catch (error) {
        console.error('Error parsing WebSocket message:', error);
      }
    });
  };

  connect();

  return {
    webSocket,
    cleanup: () => {
      if (webSocket) {
        webSocket.close();
      }
    }
  };
}

export default createWebSocket;
